(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bd-price-estimator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const euro = new Intl.NumberFormat('fr-BE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    });

    const text = (root, selector) => root.querySelector(selector)?.value?.trim() || '';
    const number = (root, selector) => Math.max(0, Number(root.querySelector(selector)?.value || 0));
    const checked = (root, selector) => Boolean(root.querySelector(selector)?.checked);
    const radio = (root, namePart) => root.querySelector(`input[name*="${namePart}"]:checked`)?.value || '';

    function selectedIsMinimum(select) {
      return Boolean(select?.selectedOptions?.[0]?.hasAttribute('data-minimum'));
    }

    function floorValue(root, prefix) {
      const select = root.querySelector(`[data-field="${prefix}-floor"]`);
      if (!select) return 0;
      if (select.value !== 'other') return Number(select.value);
      const other = root.querySelector(`[data-field="${prefix}-floor-other"]`);
      return other?.value === '' ? 3 : Math.max(0, Number(other?.value || 0));
    }

    function updateOtherFloor(root, prefix) {
      const select = root.querySelector(`[data-field="${prefix}-floor"]`);
      const input = root.querySelector(`[data-field="${prefix}-floor-other"]`);
      const wrap = input?.closest('[data-other-floor]');
      if (!select || !wrap) return;
      wrap.hidden = select.value !== 'other';
    }

    function pricingConfig(root) {
      return {
        simple: Number(root.dataset.simpleRate || 30),
        medium: Number(root.dataset.mediumRate || 35),
        complex: Number(root.dataset.complexRate || 40),
        overtime: Number(root.dataset.overtimeRate || 30),
        kilometer: Number(root.dataset.kilometerRate || 0.5),
        dayHours: Number(root.dataset.dayHours || 8),
        mediumSizeMultiplier: Number(root.dataset.mediumSizeMultiplier || 1.2),
        largeSizeMultiplier: Number(root.dataset.largeSizeMultiplier || 1.5),
        lift: Number(root.dataset.liftRate || 350),
        furniture: Number(root.dataset.furnitureRate || 20),
        heavyItemMultiplier: Number(root.dataset.heavyItemMultiplier || 1.2),
        clearanceStartingPrice: Number(root.dataset.clearanceStartingPrice || 500)
      };
    }

    function sizePricing(root, prices) {
      const size = radio(root, 'bd-size-') || 'small';
      if (size === 'medium') {
        return { key: size, label: 'Moyen', multiplier: prices.mediumSizeMultiplier };
      }
      if (size === 'large') {
        return { key: size, label: 'Grand', multiplier: prices.largeSizeMultiplier };
      }
      return { key: 'small', label: 'Petit', multiplier: 1 };
    }

    function complexity(root, prices) {
      const departureFloor = floorValue(root, 'departure');
      const arrivalFloor = floorValue(root, 'arrival');
      const parkingDifficult = !checked(root, '[data-field="departure-parking"]') || !checked(root, '[data-field="arrival-parking"]');
      const longCarry = checked(root, '[data-field="long-carry"]');
      const highFloor = departureFloor >= 2 || arrivalFloor >= 2;
      const anyFloor = departureFloor >= 1 || arrivalFloor >= 1;

      if (longCarry || highFloor) {
        return { key: 'complex', label: 'Complexe', rate: prices.complex };
      }
      if (parkingDifficult || anyFloor) {
        return { key: 'medium', label: 'Moyen', rate: prices.medium };
      }
      return { key: 'simple', label: 'Simple', rate: prices.simple };
    }

    function furniturePricing(root, prices) {
      const type = radio(root, 'bd-furniture-service-') || 'none';
      const count = type === 'none' ? 0 : Math.max(1, number(root, '[data-field="furniture-count"]'));
      const operations = type === 'both' ? 2 : type === 'none' ? 0 : 1;
      const labels = {
        none: 'Aucun',
        assembly: 'Montage',
        disassembly: 'Demontage',
        both: 'Montage et demontage'
      };
      return {
        type,
        label: labels[type],
        count,
        operations,
        total: count * operations * prices.furniture
      };
    }

    function updateFurnitureCount(root) {
      const wrap = root.querySelector('[data-furniture-count-wrap]');
      if (!wrap) return;
      wrap.hidden = (radio(root, 'bd-furniture-service-') || 'none') === 'none';
    }

    function movingSummary(root, result) {
      const sizeLabels = {
        small: "Petit - jusqu'a 85 m2",
        medium: 'Moyen - plus de 85 a 150 m2',
        large: 'Grand - plus de 150 m2'
      };
      const workersSelect = root.querySelector('[data-field="workers"]');
      const daysSelect = root.querySelector('[data-field="days"]');
      const lines = [
        'Service: Demenagement',
        `Surface: ${sizeLabels[radio(root, 'bd-size-')] || 'Non precisee'}`,
        `Depart: ${text(root, '[data-field="departure-address"]') || 'Non precise'} - etage ${floorValue(root, 'departure')} - ascenseur ${checked(root, '[data-field="departure-elevator"]') ? 'oui' : 'non'} - stationnement proche ${checked(root, '[data-field="departure-parking"]') ? 'oui' : 'non'}`,
        `Arrivee: ${text(root, '[data-field="arrival-address"]') || 'Non precisee'} - etage ${floorValue(root, 'arrival')} - ascenseur ${checked(root, '[data-field="arrival-elevator"]') ? 'oui' : 'non'} - stationnement proche ${checked(root, '[data-field="arrival-parking"]') ? 'oui' : 'non'}`,
        `Objets lourds: ${checked(root, '[data-field="heavy-items"]') ? 'oui' : 'non'}`,
        `Longue distance de portage: ${checked(root, '[data-field="long-carry"]') ? 'oui' : 'non'}`,
        `Montage / demontage: ${result.furniture.label}`,
        `Nombre de meubles: ${result.furniture.count}`,
        `Demenageurs estimes: ${workersSelect?.selectedOptions?.[0]?.textContent || ''}`,
        `Jours estimes: ${daysSelect?.selectedOptions?.[0]?.textContent || ''}`,
        `Heures supplementaires estimees: ${number(root, '[data-field="overtime"]')}`,
        `Trajet total estime: ${number(root, '[data-field="distance"]')} km`,
        `Complexite calculee: ${result.level.label} - ${result.level.rate} EUR HTVA/h/demenageur`,
        `Coefficient de surface: x${result.size.multiplier}`,
        `Coefficient objets lourds: x${result.heavyMultiplier}`,
        `Lifts estimes: ${result.liftCount} x ${euro.format(result.prices.lift)}`,
        `Montage / demontage: ${euro.format(result.furniture.total)}`,
        `Estimation: ${result.minimum ? 'a partir de ' : ''}${euro.format(result.total)} HTVA`,
        'Estimation non contractuelle, a confirmer apres verification.'
      ];
      return lines.join('\n');
    }

    function clearanceSummary(root) {
      return [
        'Service: Vide-maison',
        `Type de bien: ${text(root, '[data-field="property-type"]') || 'Non precise'}`,
        `Surface: ${number(root, '[data-field="clearance-area"]') || 'Non precisee'} m2`,
        `Adresse: ${text(root, '[data-field="clearance-address"]') || 'Non precisee'}`,
        `Details: ${text(root, '[data-field="clearance-details"]') || 'Non precises'}`,
        'Tarif a confirmer apres visite ou analyse.'
      ].join('\n');
    }

    function update(root) {
      const service = radio(root, 'bd-service-') || 'moving';
      const price = root.querySelector('[data-result-price]');
      const label = root.querySelector('[data-result-label]');
      const complexityLine = root.querySelector('[data-result-complexity]');
      const breakdown = root.querySelector('[data-result-breakdown]');
      const serviceInput = root.querySelector('[data-contact-service]');
      const summaryInput = root.querySelector('[data-contact-summary]');

      root.querySelectorAll('[data-service-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.servicePanel !== service;
      });

      if (service === 'moving') {
        const workersSelect = root.querySelector('[data-field="workers"]');
        const daysSelect = root.querySelector('[data-field="days"]');
        const workers = Number(workersSelect?.value || 1);
        const days = Number(daysSelect?.value || 1);
        const overtimeHours = number(root, '[data-field="overtime"]');
        const distance = number(root, '[data-field="distance"]');
        const prices = pricingConfig(root);
        const level = complexity(root, prices);
        const size = sizePricing(root, prices);
        const furniture = furniturePricing(root, prices);
        const heavyMultiplier = checked(root, '[data-field="heavy-items"]') ? prices.heavyItemMultiplier : 1;
        const baseLabor = workers * days * prices.dayHours * level.rate;
        const labor = baseLabor * size.multiplier * heavyMultiplier;
        const overtime = workers * overtimeHours * prices.overtime;
        const travel = distance * prices.kilometer;
        const departureNeedsLift = floorValue(root, 'departure') >= 1;
        const arrivalNeedsLift = floorValue(root, 'arrival') >= 1;
        const liftCount = Number(departureNeedsLift) + Number(arrivalNeedsLift);
        const lift = liftCount * prices.lift;
        const total = labor + overtime + travel + lift + furniture.total;
        const minimum = selectedIsMinimum(workersSelect) || selectedIsMinimum(daysSelect);
        const result = { labor, overtime, travel, lift, liftCount, furniture, heavyMultiplier, total, level, size, prices, minimum };

        label.textContent = minimum ? 'Estimation minimale indicative' : 'Estimation indicative';
        price.textContent = `${minimum ? '\u00c0 partir de ' : ''}${euro.format(total)} HTVA`;
        complexityLine.textContent = `Complexit\u00e9 estim\u00e9e : ${level.label.toLowerCase()}`;
        breakdown.hidden = false;
        root.querySelector('[data-labor-label]').textContent = "Main-d'oeuvre";
        root.querySelector('[data-labor]').textContent = euro.format(labor);
        root.querySelector('[data-overtime-price]').textContent = euro.format(overtime);
        root.querySelector('[data-travel]').textContent = euro.format(travel);
        root.querySelector('[data-lift-label]').textContent = liftCount > 1 ? `Lifts (${liftCount})` : 'Lift';
        root.querySelector('[data-lift-price]').textContent = euro.format(lift);
        root.querySelector('[data-furniture-price]').textContent = euro.format(furniture.total);
        serviceInput.value = 'Demenagement';
        summaryInput.value = movingSummary(root, result);
        return;
      }

      breakdown.hidden = true;
      const prices = pricingConfig(root);
      label.textContent = 'Prix indicatif';
      price.textContent = `\u00c0 partir de ${euro.format(prices.clearanceStartingPrice)} HTVA`;
      complexityLine.textContent = 'Devis sur demande apr\u00e8s analyse du bien.';
      serviceInput.value = 'Vide-maison';
      summaryInput.value = `${clearanceSummary(root)}\nPrix indicatif: a partir de ${euro.format(prices.clearanceStartingPrice)} HTVA.`;
    }

    function init(root) {
      if (root.dataset.bdReady === 'true') return;
      root.dataset.bdReady = 'true';

      ['departure', 'arrival'].forEach((prefix) => {
        const select = root.querySelector(`[data-field="${prefix}-floor"]`);
        select?.addEventListener('change', () => updateOtherFloor(root, prefix));
        updateOtherFloor(root, prefix);
      });

      root.querySelectorAll('input[name*="bd-furniture-service-"]').forEach((input) => {
        input.addEventListener('change', () => updateFurnitureCount(root));
      });
      updateFurnitureCount(root);

      root.addEventListener('input', () => update(root));
      root.addEventListener('change', () => update(root));
      root.querySelector('form')?.addEventListener('submit', () => update(root));
      update(root);
    }

    function initAll(scope = document) {
      if (scope.matches?.('[data-bd-estimator]')) init(scope);
      scope.querySelectorAll('[data-bd-estimator]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
